module.exports = __webpack_public_path__ + "static/media/DisneyPlus.434c99bf.png";